<!-- Desktop nav -->
<mat-menu #userMenu="matMenu">
  <button mat-menu-item
    (click)="profile.emit()">Profile</button>
  <button mat-menu-item
    (click)="logout.emit()">Log Out</button>
</mat-menu>
<mat-menu #organisationMenu="matMenu">
  <a *ngFor="let organisation of organisations | sortBy:'name':'ascending'"
    mat-menu-item
    routerLink="organisations/{{organisation.id}}">{{ organisation.name }}</a>
</mat-menu>
<mat-toolbar color="dark">
  <button mat-icon-button
    class="menu-toggle"
    (click)="sidenav.toggle()"><i class="ca-menu"></i></button>
  <a routerLink="/">

    <img src="assets/images/dashboard-logo.png">
  </a>
  <span class="fill"></span>
  <a *ngIf="admin"
    mat-button
    routerLink="/admin">Administration</a>
  <ng-container *ngIf="user">
    <button *ngIf="!currentOrganisation || organisations.length > 1"
      mat-button
      [matMenuTriggerFor]="organisationMenu">{{ currentOrganisation ? currentOrganisation.name : 'Select an Organisation' }}</button>
    <a *ngIf="organisations.length === 1"
      mat-button
      routerLink="organisations/{{organisations[0].id}}">{{ organisations[0].name }}</a>
    <button *ngIf="loggedIn"
      mat-button
      [matMenuTriggerFor]="userMenu">{{ user }}
      <mat-icon>account_circle</mat-icon>
    </button>
    <a class="appLink"
      *ngIf="appLink"
      target="_blank"
      [href]="appLink">
      <img src="assets/images/icon.png">
      <span>Open CareApp</span>
    </a>
  </ng-container>
</mat-toolbar>